// copied from apps/crm; consolidate into a shared package in S5 slice 4
import { useQuery } from "@tanstack/react-query";
import { api, client } from "../lib/api";
import type { Me } from "../lib/types";

export function useMe() {
  return useQuery({ queryKey: ["me"], queryFn: () => api.me(client) as Promise<Me>, staleTime: 60_000 });
}

export type Role = "installer_internal" | "installer_external" | "other";

/** The role decides everything the portal shows: an external party sees its own
 *  jobs and its own labour; an internal crew sees every Team Artemis job and no rates. */
export function useRole() {
  const me = useMe();
  const actorRole = me.data?.actor?.role;
  const role: Role = actorRole === "installer_external" ? "installer_external" : actorRole === "installer_internal" ? "installer_internal" : "other";
  const isExternal = role === "installer_external";
  const orgId = me.data?.actor?.org_id ?? null;
  const partyName = me.data?.party?.name ?? (isExternal ? orgId ?? "" : "Team Artemis");
  // party_id for complete_work_order: the org for an external party; the user for an internal crew member.
  const partyId = me.data?.party?.id ?? orgId ?? me.data?.user.id ?? "";
  const teamRole=me.data?.installer_member?.team_role??null;
  return { ...me, role, isExternal, isInternal: role === "installer_internal", isManager:teamRole==='manager',isWorker:teamRole==='worker',canInstall:me.data?.installer_member?.can_install??false,teamRole, orgId, partyName, partyId, userId: me.data?.user.id ?? null };
}
